// Staging environment configuration

const environment = {
    production: false,
    backendUrl: 'https://flamenavigatorstaging.tizbi.com/',
    sellneticsUrl: 'https://stage.sellnetics.com/sellnetics-av18/login-request',
    appVersion: require('../../package.json').version,
    environment: 'staging'
}

export default environment

